<div>
    <div class="header">
        <mat-icon class="closer" (click)="dialogRef.close()">clear</mat-icon>
    </div>
    <div class="headline">{{data.logid}}</div>
    <div *ngIf="userIsLoaded()" class="description">
        Der Nutzer <span class="highlighted">{{currentUser.userName}}</span> hat am <span
            class="highlighted">{{data.logtime | date:"dd.MM.yyyy HH:mm:ss" }}</span> Uhr versucht die Komponente <span
            class="highlighted">{{data.logcomponent}}</span> zu nutzen. Notwendige Regeln:
    </div>
    <div *ngFor="let rule of currentRules" class="rule">
        <mat-icon *ngIf="ruleIsPermittedSomehow(rule.rulecode); else notAllowed" class="icon permitted">done</mat-icon>
        <ng-template #notAllowed>
            <mat-icon class="denied">clear</mat-icon>
        </ng-template>
        {{rule.rulename}}
        <span class="code">{{rule.rulecode}}</span>
    </div>
    <div *ngIf="rolesAreLoaded()" style="overflow-x: auto;">
        <table class="role-right-table">
            <thead>
                <tr>
                    <th></th>
                    <th *ngFor="let rule of requiredRules" class="rule-header" [ngClass]="{'permitted':ruleIsPermittedSomehow(rule),'denied':!ruleIsPermittedSomehow(rule)}">
                        {{rule}}
                    </th>
                </tr>
                <tr *ngFor="let role of currentUsersRoles">
                    <td>{{role.name}}</td>
                    <td *ngFor="let rule of requiredRules">
                        <div *ngIf="roleRightsLoaded; else loader">
                            <mat-slide-toggle [checked]="roleIsAllowedTo(role, rule)" (change)="setRoleRight($event, role, rule)"></mat-slide-toggle>
                        </div>
                        <ng-template #loader>
                            <mat-spinner [diameter]=10></mat-spinner>
                        </ng-template>
                    </td>
                </tr>
            </thead>
        </table>
    </div>
    <div *ngIf="roleRightsLoaded && allIssuesSolved()" class="all-issues-solved-footer">
        Alle Probleme sollten behoben sein. Möchten Sie den Eintrag aus dem Log entfernen?
        <div class="button" (click)="removeLogEntry()">Eintrag jetzt entfernen</div>
    </div>
</div>